export default __webpack_public_path__ + "static/media/mario2.6f8da94c.jpeg";